<template>
  <div class="page-add">
    <div class="add-title">
      {{$route.query.uuid ? "编辑": "新增"}}音频集
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      size="small"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="名称：" prop="audioSetName">
            <el-input
              placeholder="请输入音频集名称"
              v-model="ruleForm.audioSetName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="描述：" prop="audioSetDesc">
            <el-input
              :rows="3"
              type="textarea"
              placeholder="请输入音频集描述"
              v-model="ruleForm.audioSetDesc"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="分类：" prop="categoryId" required>
            <el-cascader
              class="form-select"
              v-model="ruleForm.categoryId"
              :options="categoryData"
              :props="{label: 'name', value: 'id', children: 'children'}">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="配图："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传配图'
            }"
            :show-message="showError"
          >
            <av-preview
              v-if="ruleForm.coverUrl"
              :src="ruleForm.coverUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'videoSet/img'"
              type="image"
              v-model="ruleForm.covers"
            />
            <div class="upload_tip">
              <div class="img_tip">建议尺寸：300px*300px（或1:1）</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="option_rect">
            <el-checkbox
              v-model="dragaable"
              :disabled="dragDisabled"
              class="drag-box mr16"
              >拖拽排序</el-checkbox
            >
            <butn
              style="margin-left: 10px;"
              @click="open"
              btntype="primary"
              title="音频管理"
            ></butn>
          </div>
          <el-form-item class="scale" label="音频列表：">
            <Table
              :class="{ 'list-drag': dragaable }"
              @selection-change="selectChange"
              :data="ruleForm.audioInfoList"
              row-key="uuid"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0" class="center">
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="onSubmit"
          >提交</el-button
        >
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
    <ConfigSelect
      v-if="selectDialogInfo.flag"
      :showSelect="selectDialogInfo"
      @confirm="onFilter"
      @close="closeSelect"
      :uuid="$route.query.uuid"
     />
  </div>
</template>

<script>
import butn from "@/components/button/index";
import Sortable from "sortablejs";
import Table from "./table.js";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import { getAudiosetInfo, audioSetUpdate, audioSetSave } from "@/api/audioSet";
import { resCategoryTree } from "@/api/rescategory";
import { findTrackById } from '@/utils/shared'
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index.vue";
import ConfigSelect from "./configSelectDialog.vue";

export default {
  components: { ConfigSelect, Table, butn, Upload, AvPreview , BackButton},
  data() {
    return {
      selectDialogInfo: {
        flag: false,
        selectedList: []
      },
      pathOptions: {
        path: "/audioSet",
      },
      value: [],
      filterMethod(query, item) {
        return item.videoName.indexOf(query) > -1;
      },
      ruleForm: {
        audioSetName: "",
        audioSetDesc: "",
        categoryId: "",
        coverUrl: "",
        covers: [],
        audioInfoList: []
      },
      data: [],
      props: {
        key: "uuid",
        label: "videoName"
      },
      showError: false,
      categoryData: [],
      rules: {
        audioSetName: [
          {
            required: true,
            message: "请输入音频集名称",
            trigger: ["blur", "change"]
          },
          {
            min: 0,
            max: 50,
            message: "最多输入50个字",
            trigger: "change"
          }
        ],
        audioSetDesc: [
          {
            required: true,
            message: "请输入音频集描述",
            trigger: ["blur", "change"]
          },
          {
            min: 0,
            max: 200,
            message: "最多输入200个字",
            trigger: "change"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请输入音频集分类",
            trigger: ["blur", "change"]
          }
        ]
      },
      dragaable: false, //控制拖拽排序,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
    dragaable(val) {
      this.rowDrop(val);
    },
    "ruleForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.ruleForm.coverUrl = val[0].url;
          this.showError = false;
        } else {
          this.ruleForm.coverUrl = "";
          this.showError = true;
        }
      }
    }
  },
  created() {
    if (this.$route.query.uuid) {
      Promise.all([
        getAudiosetInfo({ uuid: this.$route.query.uuid }).then(res => {
          if (!res || res.code != 0) return;
          this.ruleForm.audioSetName = res.data.audioSetName;
          this.ruleForm.audioSetDesc = res.data.audioSetDesc;
          this.ruleForm.categoryId = res.data.categoryId;
          this.ruleForm.audioInfoList = res.data.audioInfoList;
          this.ruleForm["covers"] = [{ url: res.data.coverUrl }];
        }),
        // 获取音频分类数据
        resCategoryTree({
          categoryType: 2,
          display: 1
        }).then(res => {
          if (!res || res.code != 0) return;
          this.categoryData = res.data;
        })
      ]).then(() => {
        this.$nextTick(() => {
          if (this.ruleForm.categoryId && (this.categoryData && this.categoryData.length)) {
            const track = findTrackById(this.categoryData, this.ruleForm.categoryId, 'id')
            if (track && track.length) {
              this.ruleForm.categoryId = track
            }
          }
        })
      }).catch(_ => _)
    } else {
      // 获取音频分类数据
      resCategoryTree({
        categoryType: 2,
        display: 1,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.categoryData = res.data;
      });
    }
    // 音频列表删除时同步穿梭框状态
    vue.$on("deleteVideoSet", index => {
      this.ruleForm.audioInfoList.splice(index, 1);
    });
  },
  beforeDestroy() {
    vue.$off("deleteVideoSet");
  },
  computed: {
    dragDisabled() {
      if (
        !this.ruleForm.audioInfoList ||
        this.ruleForm.audioInfoList.length < 2
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    }
  },
  methods: {
    onFilter(payload) {
      this.ruleForm.audioInfoList = payload || [];
      this.selectDialogInfo.flag = false
    },
    open() {
      this.selectDialogInfo = {
        flag: true,
        selectedList: this.ruleForm.audioInfoList,
      }
    },
    closeSelect() {
      this.selectDialogInfo.flag = false
    },
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 结束拖拽的时候
          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.ruleForm.audioInfoList.splice(oldIndex, 1)[0];
            _this.ruleForm.audioInfoList.splice(newIndex, 0, currRow);
          }
        });
      }
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 删除封面
    deleteCover() {
      this.ruleForm.covers = [];
    },
    // 获取选中音频uuid集合
    getVideoUuids() {
      let audioInfoList = this.ruleForm.audioInfoList;
      this.ruleForm.audioUuids = [];
      if (audioInfoList && audioInfoList.length > 0) {
        for (let i = 0; i < audioInfoList.length; i++) {
          this.ruleForm.audioUuids.push(audioInfoList[i].uuid);
        }
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
          return;
        }
        if (valid) {
          this.getVideoUuids();
          let params = {
            ...this.ruleForm,
            onlineStatus: 0
          }
          if (params.categoryId) {
            params.categoryId = params.categoryId.pop()
          }
          delete params.covers;
          if (this.$route.query.uuid) {
            params.uuid = this.$route.query.uuid,
            audioSetUpdate(params).then(res => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.$router.back();
            });
          } else {
            audioSetSave(params).then((res) => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.$router.back();
            });
          }
        }
      });
    },
    reset() {
      const text = "确定重置吗?";
      Confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.showError = false;
        this.ruleForm.covers = [];
        this.$refs["ruleForm"].resetFields();
        this.ruleForm.audioInfoList = [];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
.btn-right {
  text-align: right;
  margin: 32px 0 12px 0;
}
.mr16 {
  margin-right: 16px;
}
.option_rect {
  text-align: right;
  margin-bottom: 12px;
}
.center {
  text-align: center;
}
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 330px;
  }
}
</style>
